import type {Dungeon} from "@/dungeons/model/Dungeon.ts";

export function dungeonCardImage(dungeon: Dungeon) {
    return dungeon.coverImage ?? [...dungeon.levels].sort((a, b) => a.sortIndex - b.sortIndex)[0]?.map.image;
}
